import { DateInput } from 'slab'

interface Dependent {
  relationship: 'spouse' | 'child' | 'self'
  date_of_birth: string
}

interface DependentBirthdaysContentProps {
  dependents: Dependent[]
  onDependentChange: (index: number, dateOfBirth: string) => void
}

export function DependentBirthdaysContent ({
  dependents,
  onDependentChange,
}: DependentBirthdaysContentProps) {
  if (dependents.length === 0) return null

  const today = new Date().toISOString().split('T')[0]

  return (
    <div className='flex flex-col gap-6 p-4 w-72'>
      <div className='flex flex-col gap-2'>
        <p className='body-bold text-gray-800'>
          Dependent birthdays
        </p>
        <p className='body-sm text-gray-500'>
          Optional but will help produce a more accurate quote
        </p>
      </div>

      <div className='flex flex-col gap-4'>
        {dependents.map((dependent, index) => {
          const inputId = `dependent-${index + 1}-birthday`
          return (
            <div key={index} className='flex flex-col gap-2'>
              <label htmlFor={inputId} className='body-sm-bold text-gray-800'>
                Dependent {index + 1} birthday
              </label>
              <DateInput
                id={inputId}
                value={dependent.date_of_birth}
                max={today}
                onChange={(e) => {
                  onDependentChange(index, e.target.value)
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
